import React, { useState } from 'react'
import { Checkbox } from 'antd'
import { useSnackbar } from 'notistack'
import Select from 'react-select'

import { usePet, useToggle, notifOps } from '../../modules'

import Modal from "../reusable/modal"

const EditUser = ({ toggle, user, visible, onPerform }) => {
    const [name, setName] = useState(user?.name)
    const [phone, setPhone] = useState(user?.phone)
    const [username, setUserName] = useState(user?.username)
    const [email, setEmail] = useState(user?.email)
    const [password, setPassword] = useState()
    const [conf, setConf] = useState()

    const [roles, setRoles] = useState([])
    const [role, setRole] = useState(user?.role ? { label: user?.role?.name, value: user?.role?._id } : {})

    const [superUser, toggleSuperUser] = useToggle(user?.issuperuser)

    const { enqueueSnackbar } = useSnackbar()

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'phone':
                setPhone(e.target.value)
                break
                
            case 'username':
                setUserName(e.target.value)
                break
                
            case 'email':
                setEmail(e.target.value)
                break
            
            case 'password':
                setPassword(e.target.value)
                break
        
            case 'conf':
                setConf(e.target.value)
                break

            default:
                break
        }
    }

    const onComplete = ({ data }, notif, ops) => {
        onPerform(data)
        notif('Changes have been saved', ops('success'))
        
        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('editUser', {
        id: user?._id,
        name,
        phone,
        username,
        email,
        password: password?.toString(),
        superUser,
        role: role?.value
    }, { notify: true, callback: onComplete, manual: true })

    usePet('roles', { limit: 100 }, { notify: true, callback: async ({ data }) => { 
        let temp = data?.roles?.map(role => ({
            label: role.name,
            value: role._id
        }))
        
        setRoles(temp)
    } })

    return (
        <Modal
            w={ 500 }
            title="Edit User"
            toggle={toggle}
            visible={visible}>
            <div className="divide-y divide-light-gray-400">
                <div>
                    <div>
                        <p className="font-bold my-3">User Details</p>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Name
                                </label>
                                <input 
                                    onChange={ modify }
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                    id="grid-first-name" 
                                    type="text" 
                                    value={ name }
                                    name="name"
                                    placeholder="Evans Kimani" />
                            </div>
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Phone
                            </label>
                            <input 
                                onChange={ modify }
                                className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" 
                                id="grid-phone" 
                                type="text" 
                                value={ phone }
                                name="phone"
                                placeholder="07XXXXXXXX" />
                        </div>
                        </div>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full md:w-1/3 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                                    Username
                                </label>
                                <input value={ username } onChange={ modify } name="username" className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-username" type="text" placeholder="username" />
                            </div>
                            <div className="w-full md:w-2/3 px-3">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-email">
                                    Email
                                </label>
                                <input value={ email } onChange={ modify } name="email" className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-email" type="text" placeholder="person@email.com" />
                                <p className="text-gray-500 text-xs italic">Optional</p>
                            </div>
                        </div>
                        <div className="flex flex-wrap -mx-3">
                            <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password">
                                    Password
                                </label>
                                <input value={ password } onChange={ modify } name="password" className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-password" type="password" placeholder="**********" />
                            </div>
                            <div className="w-full md:w-1/2 px-3">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-password-conf">
                                    Confirm Password
                                </label>
                                <input value={ conf } onChange={ modify } name="conf" className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-password-conf" type="password" placeholder="**********" />
                            </div>
                        </div>
                    </div>

                </div>
                <div>
                    <p className="font-bold my-3">User Roles</p>
                    <div className="flex flex-wrap -mx-3">
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-4" htmlFor="grid-name">
                                Super User
                            </label>
                            <Checkbox checked={ superUser } onChange={ () => {
                                toggleSuperUser()
                                setRole([])
                            } }>User is an Super User</Checkbox>
                        </div>
                        <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                Select Role
                            </label>
                            <Select
                                isDisabled={ superUser }
                                value={ role }
                                onChange={ setRole }
                                options={ roles }
                                placeholder="Nurse-In-Charge" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-end mt-2">
                <button disabled={ loading } onClick={ () => {
                    if (conf === password) {
                        execute()
                    } else {
                        enqueueSnackbar('Please ensure that your password match', notifOps('warning'))
                    }
                }} type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save Changes</button>
            </div>
        </Modal>
    )
}

export default EditUser